export default "/images/c02010e853ae11b5dbb18939f5860756.avif";